import type { AlertProps } from '@inato/ui';
import { Alert } from '@inato/ui';
import type React from 'react';

import type { NotificationType } from '../../../application/NotificationService';

const notificationTypeToSemantic = (
  type: NonNullable<NotificationType['type']>,
): AlertProps['semantic'] => {
  switch (type) {
    case 'info':
      return 'warning';
    case 'success':
      return 'primary';
    case 'danger':
      return 'danger';
  }
};
export const Notification = ({
  type,
  onClick,
  children,
}: React.PropsWithChildren<{
  type: NonNullable<NotificationType['type']>;
  onClick?: () => void;
}>) => (
  <Alert semantic={notificationTypeToSemantic(type)} onClick={onClick}>
    {children}
  </Alert>
);
